module.exports = __webpack_public_path__ + "img/pileta-de-natacion.91df8639.svg";